export default function isInternalCall(data: string): boolean {
  return data.includes('Alert-Info: <http://www.notused.com>;info=alert-internal');
}
